module.exports = __webpack_public_path__ + "img/news2-5.ecd61d08.png";